import { CopyableText } from "../../components";
import { BasicCollectionController, column } from "../../types";

const columns: column[] = [
  {
    title: "Id",
    dataIndex: "_id",
    key: "_id",
    dataType: "string",
    render: (text: string) => {
      return <CopyableText>{text}</CopyableText>;
    },
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    dataType: "number",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    dataType: "string",
    render: (text: string) => {
      return text.capitalize();
    },
  },
  {
    title: "Province",
    dataIndex: ["province", "name"],
    key: ["province", "name"],
    dataType: "string",
    render: (text: string) => {
      return text.capitalize();
    },
  },
];

const form: any = {
  type: "form",
  requestType: "create",
  items: [
    {
      type: "grid",
      space: 2,
      items: [
        {
          type: "field",
          name: "name",
          label: "Name",
          span: 12,
          item: {
            type: "text",
            placeholder: "name",
            format: {
              onChange: "removeExtraSpaces",
              onsubmit: "trim",
            },
          },
          validations: {
            required: true,
          },
        },
        {
          type: "field",
          name: "code",
          label: "Code",
          span: 3,
          item: {
            type: "text",
            placeholder: "code",
            format: {
              onChange: "trim",
            },
          },
          validations: {
            required: true,
          },
        },
        {
          type: "field",
          name: "province",
          label: "Province",
          validations: {
            required: true,
          },
          span: 9,
          item: {
            type: "select",
            placeholder: "Select province",
            search: true,
            mode: "default",
          },
          remote: {
            url: `${process.env.REACT_APP_API_URL}/api/provinces?search={{value}}`,
            fetchOnMount: true,
            value: "_id",
          },
        },
        {
          type: "button",
          inputType: "submit",
          value: "Submit",
          span: 12,
        },
      ],
    },
  ],
};

export class AirportController extends BasicCollectionController {
  constructor() {
    super("Airport", "airports", {
      columns,
      form,
    });
  }
}
